// src/app/services/posthog.service.ts
import { DestroyRef, Injectable, NgZone } from "@angular/core";
import posthog from "posthog-js";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { EnvService } from "./environment.service";

@Injectable({ providedIn: "root" })
export class PosthogService {
  constructor(
    private ngZone: NgZone,public environment: EnvService
  ) {
    this.initPostHog();
  }
  private initPostHog() {
    this.ngZone.runOutsideAngular(() => {
      posthog.init(this.environment.posthogKey, {
        api_host: this.environment.posthogHost,
        defaults: '2025-05-24',
        //disable_session_recording: true, // to disable the session recording globally

        // handle screen views manually
        capture_pageview: false,
        capture_pageleave: true,
        // Enable automatic capturing of page views, clicks, form submissions etc.,
        autocapture: false,
      });
    });
  }

  /** Capture an event */
  captureEvent(eventName: string, properties?: Record<string, any>) {
    const userDetails = localStorage.getItem('user');
    let addedProperties;
    if (userDetails) {
      const user = JSON.parse(userDetails);
      addedProperties = {
        uid: user.id,
        email: user.email,
        guid: user.guid,
        subscription: localStorage.getItem('plan'),
        app: "webapp",
        appversion: 'AP-4.1.12'
      }
    }
    const finalProps = {
      ...addedProperties,
      ...properties
    };
    this.ngZone.runOutsideAngular(() => {
      posthog.capture(eventName.toLowerCase(), finalProps);
    });
  }

  /** Stop session recording */
  stopRecording() {
    posthog.stopSessionRecording();
  }

  /** Start session recording */
  startRecording() {
    posthog.startSessionRecording();
  }

  identifyUser(user) {
    posthog.identify(user.id, {
      email: user.email,
      sessionId: posthog.get_session_id()
    });
  }
}